// Source: SNP, Binh Duong, Vuon Tri Thuc

import BookNewsSNP from './SnpBookNews';

export default BookNewsSNP;
